import React from 'react'
import ItemSelectableSimple from '../ItemSelectable/ItemSelectableSimple'

const AccessOpenings = ({ accessOpenigs, selectOpening }) => {
    return (
        <div className='d-flex flex-column gap-3 mb-3'>
            {
                accessOpenigs.map((accessOpenigs, idx) =>
                    <ItemSelectableSimple key={idx} onClick={() => selectOpening(accessOpenigs)}>
                        {accessOpenigs.descripcion}
                    </ItemSelectableSimple>
                )
            }
        </div>
    )
}

export default AccessOpenings